import actions from './actions'
import mutations from './mutations'
import state from './state'
import getters from './getters'

const brand = {
  namespaced: true,

  state,
  getters,
  actions,
  mutations
}

export default brand
